import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { SftpImportConfigurationWorkflow } from '../../../store/Models/Api/SftpImportModels';
import { ToxnotComponent, ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';
import TextInput from '../../core/TextInput';

interface ProductIdentificationSectionLocalProps {
    configData: SftpImportConfigurationWorkflow;
    onConfigChange: (data: Partial<SftpImportConfigurationWorkflow>) => void;
    readOnly?: boolean;
    showValidation?: boolean;
}

interface ProductIdentificationSectionState {
    showDescriptionPlantSupplier: boolean;
}

type ProductIdentificationSectionProps = ProductIdentificationSectionLocalProps & ToxnotComponentProperties;

class ProductIdentificationSectionComponent extends ToxnotComponent<ProductIdentificationSectionProps, ProductIdentificationSectionState> {
    constructor(props: ProductIdentificationSectionProps) {
        super(props);
        this.state = {
            showDescriptionPlantSupplier: false
        };
    }

    private toggleDescriptionPlantSupplier = () => {
        this.setState(prevState => ({ showDescriptionPlantSupplier: !prevState.showDescriptionPlantSupplier }));
    }

    render() {
        const { configData, onConfigChange, readOnly = false, showValidation = true } = this.props;
        const { showDescriptionPlantSupplier } = this.state;

        return (
            <>
                <div className="start-subcontent-heading">
                    {this.localizeString("Identifying Information")}
                </div>
                <div className="start-subcontent-content-container big-margin-bottom">
                    <div className="form-group">
                        <span className="mode-description"></span> {this.localizeString("Product/Material Name")}<br/>
                        <TextInput
                            value={configData.name || ""}
                            onValueChange={value => !readOnly && onConfigChange({ name: value })}
                            additionalClass="form-control"
                            placeholder={this.localizeString("Name")}
                            disabled={readOnly}
                        />
                        {showValidation && !readOnly && (!configData.name || configData.name.trim() === "") && (
                            <small className="form-text text-danger">{this.localizeString("Product/Material name is required.")}</small>
                        )}
                    </div>
                    {!readOnly && (
                        <p>
                            <a role="button" onClick={this.toggleDescriptionPlantSupplier}>
                                {this.localizeString("Add Description, Plant, Supplier, etc.")}
                            </a>
                        </p>
                    )}
                    {(showDescriptionPlantSupplier || readOnly) && (
                        <div>
                            {(configData.description || !readOnly) && (
                                <div className="form-group">
                                    <span className="mode-description"></span> {this.localizeString("Description (optional)")}<br/>
                                    <TextInput
                                        value={configData.description || ""}
                                        onValueChange={value => !readOnly && onConfigChange({ description: value })}
                                        additionalClass="form-control"
                                        placeholder={this.localizeString("Description")}
                                        disabled={readOnly}
                                    />
                                </div>
                            )}
                            {(configData.plant || !readOnly) && (
                                <div className="form-group">
                                    {this.localizeString("Plant Name (optional)")}<br/>
                                    <TextInput
                                        value={configData.plant || ""}
                                        onValueChange={value => !readOnly && onConfigChange({ plant: value })}
                                        additionalClass="form-control"
                                        placeholder={this.localizeString("Plant Name")}
                                        disabled={readOnly}
                                    />
                                </div>
                            )}
                            {(configData.supplierName || !readOnly) && (
                                <div className="form-group">
                                    {this.localizeString("Supplier Name (optional)")}<br/>
                                    <TextInput
                                        value={configData.supplierName || ""}
                                        onValueChange={value => !readOnly && onConfigChange({ supplierName: value })}
                                        additionalClass="form-control"
                                        placeholder={this.localizeString("Supplier Name")}
                                        disabled={readOnly}
                                    />
                                </div>
                            )}
                            {(configData.productNumber || !readOnly) && (
                                <div className="form-group">
                                    {this.localizeString("Product Number (optional)")}<br/>
                                    <TextInput
                                        value={configData.productNumber || ""}
                                        onValueChange={value => !readOnly && onConfigChange({ productNumber: value })}
                                        additionalClass="form-control"
                                        placeholder={this.localizeString("Product Number")}
                                        disabled={readOnly}
                                    />
                                </div>
                            )}
                            {(configData.supplierPartNumber || !readOnly) && (
                                <div className="form-group">
                                    {this.localizeString("Supplier Part Number (optional)")}<br/>
                                    <TextInput
                                        value={configData.supplierPartNumber || ""}
                                        onValueChange={value => !readOnly && onConfigChange({ supplierPartNumber: value })}
                                        additionalClass="form-control"
                                        placeholder={this.localizeString("Supplier Part Number")}
                                        disabled={readOnly}
                                    />
                                </div>
                            )}
                            {(configData.externalDbId || !readOnly) && (
                                <div className="form-group">
                                    {this.localizeString("External ID (optional)")}<br/>
                                    <TextInput
                                        value={configData.externalDbId || ""}
                                        onValueChange={value => !readOnly && onConfigChange({ externalDbId: value })}
                                        additionalClass="form-control"
                                        placeholder={this.localizeString("External ID")}
                                        disabled={readOnly}
                                    />
                                </div>
                            )}
                        </div>
                    )}
                </div>
                <div className="start-subcontent-separator"></div>
            </>
        );
    }
}

export const ProductIdentificationSection = connect(
    (state: ApplicationState) => ({ appServices: state.appServices! })
)(ProductIdentificationSectionComponent);
